import { render } from "./WatchlistHistory.vue?vue&type=template&id=59094ec4&scoped=true"
import script from "./WatchlistHistory.vue?vue&type=script&lang=js"
export * from "./WatchlistHistory.vue?vue&type=script&lang=js"

import "./WatchlistHistory.vue?vue&type=style&index=0&id=59094ec4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59094ec4"]])

export default __exports__